export default __webpack_public_path__ + "static/media/grafema_illustrations-ua-campaign_07.62029bd6.gif";